import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import './MemoryGame.css';

// Update these icon names to whatever you want from any Iconify collection.
const cardIcons = [
  { icon: 'noto:green-apple', matched: false },
  { icon: 'noto:banana', matched: false },
  { icon: 'game-icons:cherry', matched: false },
  { icon: 'noto:grapes', matched: false },
  { icon: 'noto:orange-circle', matched: false },
  { icon: 'noto-v1:strawberry', matched: false },
];

export default function MemoryGame() {
  const [cards, setCards] = useState([]);
  const [firstChoice, setFirstChoice] = useState(null);
  const [secondChoice, setSecondChoice] = useState(null);
  const [disabled, setDisabled] = useState(false);

  // Initialize a new game by shuffling cards
  const shuffleCards = () => {
    const shuffledCards = [...cardIcons, ...cardIcons]
      .sort(() => Math.random() - 0.5)
      .map(card => ({ ...card, id: Math.random() }));
    
    setCards(shuffledCards);
    setFirstChoice(null);
    setSecondChoice(null);
  };

  // Handle card selection
const handleChoice = (card) => {
  if (card !== firstChoice) {
    firstChoice ? setSecondChoice(card) : setFirstChoice(card);
  }
};


  // Check if two selected cards match
  useEffect(() => {
    if (firstChoice && secondChoice) {
      setDisabled(true);
      if (firstChoice.icon === secondChoice.icon) {
        setCards(prevCards => {
          return prevCards.map(card => {
            if (card.icon === firstChoice.icon) {
              return { ...card, matched: true };
            } else {
              return card;
            }
          });
        });
        resetTurn();
      } else {
        setTimeout(() => resetTurn(), 1000);
      }
    }
  }, [firstChoice, secondChoice]);

  // Reset choices and enable clicks again
  const resetTurn = () => {
    setFirstChoice(null);
    setSecondChoice(null);
    setDisabled(false);
  };

  // Start a new game on component mount
  useEffect(() => {
    shuffleCards();
  }, []);

  return (
    <div className="memory-game">
      <h1>Memory Game</h1>
      <button onClick={shuffleCards}>New Game</button>
      <div className="card-grid-memory">
        {cards.map(card => (
          <div
            className={`card-memory ${card === firstChoice || card === secondChoice || card.matched ? 'flipped' : ''}`}
            key={card.id}
            onClick={() => !disabled && !card.matched && handleChoice(card)}
          >
            {card.matched || card === firstChoice || card === secondChoice ? (
              <Icon icon={card.icon} width="50" height="50" />
            ) : (
              <Icon icon="material-symbols:lock" width="50" height="50" /> // Back of the card
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
